// import { formatPhoneNumber } from 'react-phone-number-input'

export default function displayPhone(phoneNumber: string): string {
  return phoneNumber
}

export function maskPhoneNumber(phoneNumber: string): string {
  const maskedSection = phoneNumber.slice(0, -3).replace(/./g, '*')
  const visibleSection = phoneNumber.slice(-3)
  return maskedSection + visibleSection
}

// export function formatPhoneNumberLocale(phoneNumber: string): string {
//   return formatPhoneNumber(phoneNumber) || phoneNumber
// }
